export default __webpack_public_path__ + "static/media/revolution-logo.5154f368.png";